import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { bracketParams } from "./BackgroundAssetServices";
import { BackgroundRequest, BackgroundRequestListParams, Page } from "./dtos";

const BACKGROUND_REQUEST_SERVICE = `${Constants.API_URL}/bedrock/background_requests`;

/** The background image requests an account is waiting on; non-terminal first. */
export class BackgroundRequestServices {
  @scCatchServiceException(true)
  static async list(params: BackgroundRequestListParams = {}): Promise<Page<BackgroundRequest>> {
    const { data } = await axios.get<Page<BackgroundRequest>>(BACKGROUND_REQUEST_SERVICE, {
      params,
      paramsSerializer: bracketParams,
    });
    return data;
  }

  @scCatchServiceException(true)
  static async get(id: number): Promise<BackgroundRequest> {
    const { data } = await axios.get<BackgroundRequest>(`${BACKGROUND_REQUEST_SERVICE}/${id}`);
    return data;
  }

  /** Only while `queued`. */
  @scCatchServiceException(true)
  static async cancel(id: number): Promise<BackgroundRequest> {
    const { data } = await axios.post<BackgroundRequest>(`${BACKGROUND_REQUEST_SERVICE}/${id}/cancel`);
    return data;
  }
}
